import { Text } from "@/components/ui/text";
import { Image } from "@/components/ui/image";
import { HStack } from "@/components/ui/hstack";
import { Button } from "@/components/ui/button";
import React from 'react'
import i18n from "i18n-js";
import {taskIcons} from '@/assets/images';


export default function AddStepButton({nodeType, stepType, addNode}) {
    return (
        <Button onPress={() => addNode(nodeType)} className="h-[34px] bg-primary-900">
            <HStack space='sm' className="items-center">
                <Image size='2xs' source={taskIcons[nodeType]} alt={''} className="flex-1 bg-secondary-50 rounded-md border border-[#BEBEBE]" />
                <Text className="text-secondary-50">{i18n.t('stepType.' + stepType)}</Text>
            </HStack>
        </Button>
    );
}
